import React, { Component } from 'react'
import { DataTable } from 'primereact/datatable'
import { InputText } from 'primereact/inputtext'
import { Column } from 'primereact/column'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Fieldset } from 'primereact/fieldset'

import {
  Btn,
  ConfirmDialog,
  CustomCheckbox,
  CustomPanel,
  Loading,
  PageHeader,
  CustomMultiSelect,
} from '../../../../components'
import { tableCellCentered } from '../../../../assets/js/styles'
import ListTable from './ListItem/ListItem'
import { showMessageBox } from '../../../../store/actions/system.actions'
import { errorHandler } from '../../../../services/util/error.service'
import * as StepHttp from '../../../../services/api/https/deliveries/delivery-step.http'
import { isRouteAllowed } from '../../../../services/permission/menus'
import { getEstadoLabel, normalizeUf } from '../../../../services/util/estados.service'

class Trecho extends Component {
  state = {
    entregas: [],
    entregasOriginal: [],
    selecionarTodos: false,
    isBtnLoading: false,
    isContentLoading: true,
    globalFilter: '',
    utilizarTrechosPadroes: false,
    disableTrechoEhSelecionarTodos: false,
    isBtnRemoverLoading: false,
    isBtnRemoverSelecionadosLoading: false,
    isBtnRemoverEntregaLoading: false,
    showConfirmDialog: false,
    ufOptions: [],
    selectedUfs: [],
    citiesOptions: [],
    selectedCities: [],
    bairrosOptions: [],
    selectedBairros: [],
  }

  onControlValueChange = (name, value) => {
    this.setState(state => {
      if (name === 'selecionarTodos') {
        state.entregas = this._selecionarTodos(value)
        state[name] = value
      } else if (name === 'utilizarTrechosPadroes') {
        state.disableTrechoEhSelecionarTodos = value
        state.entregas = this._selecionarTodos(false)
        state.selecionarTodos = false
        state[name] = value
      } else {
        state[name] = value
      }
      return state
    })
  }

  onBtnSalvarClicked = async () => {
    try {
      let entregasComTrechos
      const { entregas, utilizarTrechosPadroes } = this.state
      const {
        selectedTp: tp_id,
        selectedCiclo: { cicloId },
      } = this.props

      this.setState({ isBtnLoading: true })

      if (utilizarTrechosPadroes) {
        // Verificando se existe algum trecho já associado
        if (entregas.filter(e => e.steps && e.steps.length > 0).length > 0)
          throw new Error('Já existem trechos associados. Desassocie e repita o processo')

        // Realizando as Associações
        const { hasError, payload } = await StepHttp.saveStepPadroes(cicloId)
        if (hasError) {
          this.props.dispatch(
            showMessageBox(
              null,
              errorHandler(`Existe(m) ${payload.length} cliente(s) sem Trecho cadastrado`),
            ),
          )
          this.props.history.push('/main/entregas/clientes-sem-trechos', {
            clientesSemTrecho: payload,
            operationcenter_id: this.props.selectedCiclo.operationcenter_id,
          })
          return
        } else {
          entregasComTrechos = payload
        }
      } else {
        const selectedEntregas = entregas.filter(e => e.selected)
        if (tp_id === 0) throw new Error('Selecione o Operador Logístico')
        if (selectedEntregas.length === 0) throw new Error('Selecione pelos menos uma Entrega')
        if (!cicloId) throw new Error('Error. Volte para a tela de Ciclo de Entregas')

        const entregasTrecho = selectedEntregas.map(e => ({
          delivery_id: e.delivery_id,
          tp_id,
        }))
        entregasComTrechos = await StepHttp.saveStep(entregasTrecho, cicloId)
      }
      this.setState({
        entregas: entregasComTrechos,
        isBtnLoading: false,
        utilizarTrechosPadroes: false,
        disableTrechoEhSelecionarTodos: false,
      })
      this.props.dispatch(showMessageBox('Trechos associados com Sucesso', null))
    } catch (error) {
      this.setState({ isBtnLoading: false })
      this.props.dispatch(showMessageBox(null, errorHandler(error)))
    }
  }

  onCheckBoxRowClicked = entrega => {
    this.setState(state => {
      const { entregas } = state
      const index = entregas.findIndex(e => e.delivery_id === entrega.delivery_id)
      if (index !== -1) {
        entrega.selected = !entrega.selected
        entregas[index] = entrega
      }
      return state
    })
  }

  onBtnRemoverTrechosClicked = async () => {
    try {
      const {
        selectedCiclo: { cicloId },
      } = this.props
      this.setState({ isBtnRemoverLoading: true })
      const entregasSemTrechos = await StepHttp.removerTrechos(cicloId)
      this.setState({
        isBtnRemoverLoading: false,
        entregas: entregasSemTrechos,
      })
      this.props.dispatch(showMessageBox('Trechos removidos com sucesso', null))
    } catch (error) {
      this.setState({ isBtnRemoverLoading: false })
      this.props.dispatch(showMessageBox(null, errorHandler(error)))
    }
  }

  onBtnRemoverTrechosSelecionadosClicked = async () => {
    try {
      const {
        selectedCiclo: { cicloId },
      } = this.props
      const { entregas } = this.state
      const selectedEntregas = entregas.filter(e => e.selected)
      if (selectedEntregas.length === 0) throw new Error('Selecione pelo menos uma Entrega')
      this.setState({ isBtnRemoverSelecionadosLoading: true })
      const deliveriesIds = selectedEntregas.map(e => e.delivery_id)
      const entregasAtualizadas = await StepHttp.removerTrechosSelecionados(cicloId, deliveriesIds)
      this.setState({
        isBtnRemoverSelecionadosLoading: false,
        entregas: entregasAtualizadas,
      })
      this.props.dispatch(showMessageBox('Trechos removidos com sucesso', null))
    } catch (error) {
      this.setState({ isBtnRemoverSelecionadosLoading: false })
      this.props.dispatch(showMessageBox(null, errorHandler(error)))
    }
  }

  onBtnRemoverEntregaClicked = () => this.setState({ showConfirmDialog: true })

  _apagarEntregas = async () => {
    try {
      this.setState({ isBtnRemoverEntregaLoading: true, showConfirmDialog: false })
      const entregas = this.state.entregas.filter(e => e.selected)
      if (entregas.length === 0) throw new Error('Selecione as entregas desejadas.')

      await StepHttp.removerEntregas(entregas.map(e => e.delivery_id))

      this.setState({
        entregas: this.state.entregas.filter(e => !e.selected),
      })

      this.props.dispatch(showMessageBox('Entregas removidas com sucesso', null))
    } catch (error) {
      this.props.dispatch(showMessageBox(null, errorHandler(error)))
    } finally {
      this.setState({ isBtnRemoverEntregaLoading: false })
    }
  }

  onDeleteTrecho = async item => {
    // item: step_id: number, step: number, itemName: string (TP Name)
    try {
      this.setState({ isBtnLoading: true })
      const entregasComTrechos = await StepHttp.deleteStep(item.step_id)
      this.setState({ entregas: entregasComTrechos, isBtnLoading: false })
    } catch (error) {
     this.setState({ isBtnLoading: false })
      this.props.dispatch(showMessageBox(null, errorHandler(error)))
    }
  }

  componentDidMount = async () => {
    try {
      const {
        selectedCiclo: { cicloId },
      } = this.props
      const entregas = await StepHttp.getDeliveriesWithStepsByCycle(cicloId)
      const ufOptions = [...new Set(entregas.map(e => normalizeUf(e.uf)).filter(Boolean))]
        .sort()
        .map(sigla => ({ label: getEstadoLabel(sigla), value: sigla }))
      const citiesOptions = [...new Set(entregas.map(e => e.city_name).filter(Boolean))]
        .sort()
        .map(c => ({ label: c, value: c }))

      this.setState({
        entregas,
        entregasOriginal: entregas, // mantém base para refiltrar
        isContentLoading: false,
        ufOptions,
        selectedUfs: [],
        citiesOptions,
        selectedCities: [],
        bairrosOptions: [],
        selectedBairros: [],
      })
    } catch (error) {
      this.props.dispatch(showMessageBox(null, errorHandler(error)))
    }
  }

  _applyLocationFilters = () => {
    const { entregasOriginal, selectedUfs, selectedCities, selectedBairros } = this.state

    let filtradasSemBairro = entregasOriginal

    if (selectedUfs.length) {
      filtradasSemBairro = filtradasSemBairro.filter(t => selectedUfs.includes(t.uf))
    }

    const citiesOptions = [...new Set(filtradasSemBairro.map(t => t.city_name).filter(Boolean))]
      .sort()
      .map(c => ({ label: c, value: c }))

    if (selectedCities.length) {
      filtradasSemBairro = filtradasSemBairro.filter(t => selectedCities.includes(t.city_name))
    }

    const bairrosOptions = [...new Set(filtradasSemBairro.map(t => t.district).filter(Boolean))]
      .sort()
      .map(b => ({ label: b, value: b }))

    let finalFiltradas = filtradasSemBairro
    if (selectedBairros.length) {
      finalFiltradas = finalFiltradas.filter(t => selectedBairros.includes(t.district))
    }

    this.setState({ citiesOptions, bairrosOptions, entregas: finalFiltradas })
  }

  onUfChange = ufs => this.setState({ selectedUfs: ufs }, this._applyLocationFilters)
  onCityChange = cities => this.setState({ selectedCities: cities }, this._applyLocationFilters)
  onBairroChange = bairros =>
    this.setState({ selectedBairros: bairros }, this._applyLocationFilters)

  // Render
  render() {
    const {
      entregas,
      selecionarTodos,
      isBtnLoading,
      isContentLoading,
      utilizarTrechosPadroes,
      disableTrechoEhSelecionarTodos,
      isBtnRemoverLoading,
      isBtnRemoverSelecionadosLoading,
      isBtnRemoverEntregaLoading,
      showConfirmDialog,
      ufOptions,
      selectedUfs,
      citiesOptions,
      selectedCities,
      bairrosOptions,
      selectedBairros,
    } = this.state
    const {
      selectedCiclo: { cicloName },
    } = this.props

    const tableHeader = (
      <div style={{ textAlign: 'left' }}>
        <i className="pi pi-search" style={{ margin: '4px 4px 0 0' }} />
        <InputText
          type="search"
          onInput={e => this.setState({ globalFilter: e.target.value })}
          placeholder="Pesquisar . . ."
          size="50"
        />
      </div>
    )

    const content = (
      <div>
        <PageHeader>
          <span>Definição dos Trechos por Entrega</span>
          <strong> - {cicloName}</strong>
        </PageHeader>
        <div style={{ marginTop: 20 }}>
          <CustomPanel onVoltar={this.props.history.goBack} showBtnNovo={false}>
            <div
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '10px',
                alignItems: 'center',
                marginBottom: '20px',
              }}
            >
              <Btn onClick={this.onBtnSalvarClicked} isLoading={isBtnLoading}>
                Salvar Trecho
              </Btn>
              <Btn onClick={this.onBtnRemoverTrechosClicked} isLoading={isBtnRemoverLoading}>
                Remover Todos os Trechos
              </Btn>
              <Btn
                onClick={this.onBtnRemoverTrechosSelecionadosClicked}
                isLoading={isBtnRemoverSelecionadosLoading}
              >
                Remover Trechos Selecionados
              </Btn>
              {isRouteAllowed(26) ? (
                <Btn
                  onClick={this.onBtnRemoverEntregaClicked}
                  isLoading={isBtnRemoverEntregaLoading}
                >
                  Remover Entregas
                </Btn>
              ) : null}
            </div>
            <div
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '20px',
                marginBottom: '20px',
                alignItems: 'center',
              }}
            >
              <div style={{ paddingTop: 32 }}>
                <CustomCheckbox
                  disabled={disableTrechoEhSelecionarTodos}
                  checked={selecionarTodos}
                  onChange={value => this.onControlValueChange('selecionarTodos', value)}
                >
                  Selecionar Todos
                </CustomCheckbox>
              </div>
              <div style={{ paddingTop: 32 }}>
                <CustomCheckbox
                  checked={utilizarTrechosPadroes}
                  onChange={value => this.onControlValueChange('utilizarTrechosPadroes', value)}
                >
                  Utilizar Trechos Padrões
                </CustomCheckbox>
              </div>
            </div>
            <Fieldset
              legend="Filtro"
              toggleable
              collapsed={true}
              className="p-col-12"
              style={{ marginBottom: 20 }}
            >
              <div style={{ display: 'flex', gap: 16 }}>
                <div className="p-col-2" style={{ minWidth: 200 }}>
                  <CustomMultiSelect
                    marginTop={10}
                    label="Estados"
                    options={ufOptions}
                    value={selectedUfs}
                    onChange={this.onUfChange}
                  />
                </div>
                <div className="p-col-2" style={{ minWidth: 200 }}>
                  <CustomMultiSelect
                    marginTop={10}
                    label="Cidades"
                    options={citiesOptions}
                    value={selectedCities}
                    onChange={this.onCityChange}
                  />
                </div>
                <div className="p-col-2" style={{ minWidth: 200 }}>
                  <CustomMultiSelect
                    marginTop={10}
                    label="Bairros"
                    options={bairrosOptions}
                    value={selectedBairros}
                    onChange={this.onBairroChange}
                  />
                </div>
              </div>
            </Fieldset>
            <div>
              <DataTable
                value={entregas}
                header={tableHeader}
                globalFilter={this.state.globalFilter}
                emptyMessage="Nenhuma entrega encontrada."
              >
                <Column
                  field="selected"
                  style={tableCellCentered(50)}
                  body={entrega => (
                    <CustomCheckbox
                      checked={entrega.selected}
                      onChange={() => this.onCheckBoxRowClicked(entrega)}
                    />
                  )}
                />
                <Column field="client_fantasia" header="Cliente" />
                <Column field="city_name" header="Cidade" style={tableCellCentered(150)} />
                <Column field="uf" header="UF" style={tableCellCentered(40)} />
                <Column field="identifier" header="Identificador" style={{ textAlign: 'center' }} />
                <Column field="weight" header="Peso" style={tableCellCentered(110)} />
                <Column field="qteSKU" header="Volumes" style={tableCellCentered(110)} />
                <Column
                  field="steps"
                  header="Trechos"
                  style={tableCellCentered(250)}
                  body={entrega => (
                    <ListTable items={entrega.steps} onDelete={item => this.onDeleteTrecho(item)} />
                  )}
                />
              </DataTable>
            </div>
          </CustomPanel>
        </div>
        <ConfirmDialog
          title="Atenção"
          content="Essa operação não poderá ser desfeita. Confirma a exclusão da(s) entregas ?"
          isVisible={showConfirmDialog}
          onCancelar={() => this.setState({ showConfirmDialog: false })}
          onOk={() => this._apagarEntregas()}
        />
      </div>
    )

    return isContentLoading ? (
      <div style={{ textAlign: 'center' }}>
        <Loading />
      </div>
    ) : (
      content
    )
  }

  _selecionarTodos = value => {
    const { entregas } = this.state
    entregas.forEach(e => (e.selected = value))
    return entregas
  }
}

const mapStateProps = ({ ciclo_entrega: { selectedCiclo }, system: { selectedTp } }) => ({
  selectedCiclo,
  selectedTp,
})
export default connect(mapStateProps)(withRouter(Trecho))
